import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { marketUrl } from "@/utils/util";

const MarketPathRedirect = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    window.location.replace(marketUrl(pathname + search + hash));
  }, [pathname, search, hash]);

  return null;
};

export default MarketPathRedirect;
